import { DismissButton } from "../../dismiss-button";
import moment from "moment-timezone";
import { RIGHTSLINE_URL } from "../../../../../config/constants";

export const tprRelease = {
  rowGroup: true,
  hide: true,
  sortable: false,
  valueGetter: (params) => {
    if (params.data?.pmxReleaseId)
      return (
        "TPR Release ID " +
        params.data?.pmxReleaseId +
        ", Title: " +
        params.data?.pmxReleaseName
      );
    else return "";
  },
  minWidth: 250,
};

export const id = {
  field: "id",
  headerName: "Exception ID",
  sortable: false,
  valueGetter: (params) => {
    if (params.data?.id) return params.data?.id;
    //?.slice(-8)
    else return "";
  },
  minWidth: 200,
};

export const exceptionStatus = {
  field: "exceptionStatus",
  headerName: "Exception Status",
  sortable: false,
  valueGetter: (params) => {
    if (params.data?.exceptionStatus)
      return (
        params.data.exceptionStatus
          ?.toLowerCase()
          .replace(/^\w/, (c) => c.toUpperCase()) ?? ""
      );
    else return "-";
  },
  minWidth: 130,
};

export const exceptionType = {
  field: "exceptionType",
  headerName: "Exception Type",
  sortable: false,
  headerComponentParams: {
    colId: "exceptionType",
    page: "tprExceptions",
  },
  valueGetter: (params) => {
    const raw = params.data?.exceptionType;
    if (!raw) return "-";
    return raw
      .replace(/_/g, " ")
      .toLowerCase()
      .split(/\s+/)
      .filter(Boolean)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  },
  minWidth: 180,
};

export const exceptionMessage = {
  field: "exception",
  headerName: "Error Message",
  sortable: false,
  headerComponentParams: {
    colId: "exception",
    page: "tprExceptions",
  },
  minWidth: 400,
};

export const licensee = {
  field: "licensee",
  headerName: "Licensee",
  sortable: false,
  valueGetter: (params) => {
    if (params.data?.licensee) return params.data.licensee.name ?? "";
    else return "-";
  },
  minWidth: 200,
};

export const exceptionDetails = {
  headerName: "Exception details",
  sortable: false,
  valueGetter: (params) => {
    return (
      "Deal: " +
      (params.data.dealName ?? " - ") +
      " (" +
      (params.data.dealId ?? " - ") +
      ") | Catalog: " +
      (params.data.catalogName ?? " - ") +
      " (" +
      (params.data.catalogId ?? " - ") +
      ") | Territory: " +
      (params.data.territoryName ?? " - ") +
      "(" +
      (params.data.territoryCode ?? " - ") +
      ") | Media: " +
      (params.data.mediaName ?? " - ") +
      " | Format: " +
      (params.data.format ?? " - ")
    );
  },
  headerComponentParams: {
    colId: "exceptionDetails",
    page: "tprExceptions",
  },
  minWidth: 700,
};

export const deal = {
  headerName: "Deal ID",
  sortable: false,
  cellRenderer: (params) => {
    const dealId = params.data?.dealId;
    if (!dealId) return "-";
    const url = RIGHTSLINE_URL("deal");
    return (
      <a
        href={`${url}${dealId}`}
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: "#4f46e5" }}
      >
        {" "}
        {dealId}{" "}
      </a>
    );
  },
  tooltipValueGetter: (params) => {
    return params.data?.dealName || "";
  },
};

export const tprCatalogId = {
  headerName: "Catalog ID",
  sortable: false,
  cellRenderer: (params) => {
    const catalogId = params.data?.catalogId;
    if (!catalogId) return "-";
    const url = RIGHTSLINE_URL("catalog");
    return (
      <a
        href={`${url}${catalogId}`}
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: "#4f46e5" }}
      >
        {" "}
        {catalogId}{" "}
      </a>
    );
  },
};

export const enterpriseProductId = {
  field: "radarId",
  headerName: "Enterprise Product ID",
  sortable: false,
  valueGetter: (params) => {
    if (params.data?.radarId != null) return params.data.radarId;
    return "-";
  },
  minWidth: 180,
};

export const tprCatalog = {
  headerName: "Catalog Name",
  sortable: false,
  valueGetter: (params) => {
    if (params.data?.catalogName) return params.data.catalogName ?? "";
    else return "-";
  },
  minWidth: 400,
};

export const tprTerritory = {
  field: "tprTerritory",
  headerName: "Territory",
  sortable: false,
  valueGetter: (params) => {
    if (params.data?.territoryId)
      return (
        (params.data.territoryName ?? "") +
        " (" +
        (params.data.territoryCode ?? "") +
        ")"
      );
    else return "-";
  },
  minWidth: 300,
};

export const tprMedia = {
  field: "tprMedia",
  headerName: "Media",
  sortable: false,
  valueGetter: (params) => {
    if (params.data?.mediaName) return params.data.mediaName ?? "";
    else return "-";
  },
};

export const tprFormat = {
  field: "tprFormat",
  headerName: "Format",
  sortable: false,
  valueGetter: (params) => {
    if (params.data?.format) return params.data.format ?? "";
    else return "-";
  },
};

export const tprStartDate = {
  field: "tprStartDate",
  headerName: "TPR Start Date",
  sortable: false,
  headerComponentParams: {
    colId: "tprStartDate",
    page: "tprExceptions",
  },
};

export const tprEndDate = {
  field: "tprEndDate",
  headerName: "TPR End Date",
  sortable: false,
  headerComponentParams: {
    colId: "tprEndDate",
    page: "tprExceptions",
  },
};

export const exceptionTimestamp = {
  field: "exceptionTimeStamp",
  headerName: "Exception Timestamp",
  sortable: false,
  headerComponentParams: {
    colId: "exceptionTimeStamp",
    page: "tprExceptions",
  },
  valueFormatter: ({ value }) =>
    value
      ? moment(moment.utc(value).toDate())
          .tz(moment.tz.guess())
          .format("MM/DD/YYYY, h:mm:ss A z")
      : "",
  minWidth: 250,
};

export const dismissed = {
  field: "dismissed",
  headerName: "Dismissed",
  sortable: false,
  headerComponentParams: {
    colId: "dismissed",
    page: "tprExceptions",
  },
  cellRenderer: DismissButton,
  cellRendererParams: (params) => ({
    data: params.data,
    dismissExceptionHandler: params.context.onDismiss,
  }),
  /*valueSetter: (params) => {
        if(params.data?.dismissed)
            return 'on'
        else
            return 'off'
    },*/
  minWidth: 80,
};

export const dismissBy = {
  field: "dismissBy",
  headerName: "Dismissed By",
  sortable: false,
  valueGetter: (params) => {
    if (params.data?.dismissBy) return params.data.dismissBy.fullName ?? "";
    else return "-";
  },
  minWidth: 250,
};
